require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-display-suite.json") })
        }
      }, "path---news-yarrabend-display-suite");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-display-suite!./.cache/json/news-yarrabend-display-suite.json
// module id = 869
// module chunks = 231608221292675